module.exports = __webpack_public_path__ + "img/icon-email.4cf80a0.svg";